<template>
  <div class="login-wrapper">
    <div class="left">
      <span>智校园</span>
      <div class="text1">管理更便捷</div>
    </div>
    <el-form ref="loginForm" :model="form" :rules="rules" class="login-form ele-bg-white" size="large" @keyup.enter.native="doSubmit">
      <h4>智校园管理系统</h4>
      <el-form-item prop="phone">
        <el-input placeholder="请输入手机号码" v-model="form.phone" maxlength="11" prefix-icon="el-icon-user" clearable />
      </el-form-item>
      <el-form-item prop="password">
        <el-input placeholder="请输入密码" v-model="form.password" maxlength="8" prefix-icon="el-icon-lock" show-password @input="getTeachSchool()" />
      </el-form-item>
      <el-form-item>
        <el-select style="width: 100%" v-model="form.schoolAccount" placeholder="请选择学校" prefix-icon="el-icon-school">
          <el-option v-for="item in schoolList" :key="item.id" :label="item.schoolName" :value="item.schoolAccount" />
        </el-select>
      </el-form-item>
      <div class="el-form-item">
        <el-button @click="doSubmit" :loading="loading" type="primary" class="login-btn" size="large">
          {{ loading ? '登录中' : '登录' }}
        </el-button>
      </div>
    </el-form>
    <div class="login-copyright">
      copyright © 2021 hbztxy.com all rights reserved.
    </div>
  </div>
</template>

<script>
  import { login, getTeacherSchools } from '../../config/api.js';
  import validate from '@/utils/validate';

  export default {
    name: 'Login',
    data() {
      return {
        loading: false, // 加载状态
        form: { phone: '', password: '', schoolAccount: '' }, // 表单数据
        rules: {
          // 表单验证规则
          phone: [{ required: true, message: '请输入手机号码', trigger: 'blur' }],
          password: [{ required: true, message: '请输入密码', trigger: 'blur' }],
        },
        schoolList: [],
        userMsg: null,
      };
    },
    mounted() {
      window.addEventListener('message', function(e) {
        // console.log(e);
        if (e.origin === 'http://hd.hdzxy.com') {
          window.opener.postMessage('getMsg', 'http://hd.hdzxy.com/business/areaSchool');
          sessionStorage.setItem('access_token', e.data.token);
          // location.reload();
          location.href = 'http://www.hdzxy.com/school/teacher';
        }
      });
      // window.addEventListener("message",function (e){
      //   console.log(e);
      //   if (e.origin === 'http://192.168.2.219:8081') {
      //     window.opener.postMessage('getMsg', 'http://192.168.2.219:8081/business/areaSchool');
      //     sessionStorage.setItem('access_token',e.data.token);
      //     location.reload();
      //   }
      // });
      if (this.$store.state.user.token) this.$router.push(this.$route.query.from || '/');
    },
    methods: {
      /* 提交 */
      doSubmit() {
        this.$refs['loginForm'].validate((valid) => {
          if (!valid) return false;
          this.loading = true;
          let formData = new FormData();
          for (let key in this.form) formData.append(key, this.form[key]);
          login(formData).then((res) => {
            // console.log(res);
            this.loading = false;
            if (res.data.resCode == 200) {
              this.$message({ type: 'success', message: '登录成功' });
              this.$store.dispatch('user/setToken', res.data.data.token).then(() => {
                // this.$router.push(this.$route.query.from || '/school/teacher')
                this.$router.push('/school/teacher');
              });
              this.$store.dispatch('user/setUser', res.data.data.teacherName);
            } else {
              this.$message.error(res.data.resMsg);
            }
          });
        });
      },

      //根据手机号 获取学校信息
      getTeachSchool() {
        if (validate.isPhone(this.form.phone)) {
          if (this.form.password != '') {
            let data = {
              phone: this.form.phone,
              password: this.form.password,
            };
            getTeacherSchools(data).then((res) => {
              if (res.data.resCode == 200) {
                this.schoolList = res.data.data;
                this.form.schoolAccount = res.data.data[0].schoolAccount;
              }
            });
          }
        }
      },
    },
  };
</script>

<style scoped>
  .left {
    position: absolute;
    display: flex;
    flex-direction: column;
    align-items: center;
    z-index: 1;
    top: 34%;
    left: 20%;
  }
  .left span {
    font-size: 40px;
    font-weight: bolder;
    color: #409eff;
  }
  .text1 {
    width: 200px;
    height: 50px;
    line-height: 50px;
    text-align: center;
    background-color: #409eff;
    border-radius: 50px;
    color: #fff;
    font-size: 20px;
  }
  .login-wrapper {
    display: flex;
    padding: 50px 20px;
    position: relative;
    box-sizing: border-box;
    background-image: url('~@/assets/bg-login.jpg');
    background-repeat: no-repeat;
    background-size: cover;
    min-height: 100vh;
  }

  .login-wrapper:before {
    content: '';
    background-color: rgba(0, 0, 0, 0.2);
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
  }

  .login-form {
    margin: 0 auto;
    width: 360px;
    max-width: 100%;
    padding: 25px 30px;
    position: relative;
    box-shadow: 0 3px 6px rgba(0, 0, 0, 0.15);
    box-sizing: border-box;
    border-radius: 4px;
    z-index: 2;
  }

  .login-form h4 {
    font-weight: bold;
    text-align: center;
    margin: 0 0 25px 0;
  }

  .login-form > .el-form-item {
    margin-bottom: 25px;
  }

  .login-input-group {
    display: flex;
    align-items: center;
  }

  .login-input-group >>> .el-input {
    flex: 1;
  }

  .login-captcha {
    height: 38px;
    width: 102px;
    margin-left: 10px;
    border-radius: 4px;
    border: 1px solid #dcdfe6;
    text-align: center;
    cursor: pointer;
  }

  .login-captcha:hover {
    opacity: 0.75;
  }

  .login-btn {
    display: block;
    width: 100%;
  }

  .login-oauth-icon {
    color: #fff;
    padding: 5px;
    margin: 0 10px;
    font-size: 18px;
    border-radius: 50%;
    cursor: pointer;
  }

  .login-copyright {
    color: #eee;
    padding-top: 20px;
    text-align: center;
    position: relative;
    z-index: 1;
  }

  @media screen and (min-height: 550px) {
    .login-form {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translateX(-50%);
      margin-top: -250px;
    }

    .login-copyright {
      position: absolute;
      bottom: 20px;
      right: 0;
      left: 0;
    }
  }
</style>
